import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {TRANSITION_CLASS_LEFT, TRANSITION_CLASS_RIGHT, TRANSITION_DURATION, ENTRANCE_CLASS_LEFT, ENTRANCE_CLASS_RIGHT} from './carousel-constants.js'

/* Mahabalipuram images */
import MahabalipuramFrontCow from '../../../assets/img/carousel/Mahabalipuram/1-cow.png';
import MahabalipuramFrontPeople from '../../../assets/img/carousel/Mahabalipuram/1-front-people.png';
import MahabalipuramLighthouse from '../../../assets/img/carousel/Mahabalipuram/2-lighthouse.png';
import MahabalipuramHouseLeft from '../../../assets/img/carousel/Mahabalipuram/3-house-left.png';
import MahabalipuramTempleRight from '../../../assets/img/carousel/Mahabalipuram/3-temple-right.png';
import MahabalipuramRock from '../../../assets/img/carousel/Mahabalipuram/4-rock.png';
import MahabalipuramBirdsLeft from '../../../assets/img/carousel/Mahabalipuram/5-birds-left.png';
import MahabalipuramBirdsRight from '../../../assets/img/carousel/Mahabalipuram/5-birds-right.png';
import MahabalipuramGate from '../../../assets/img/carousel/Mahabalipuram/6-gate.png';
import MahabalipuramSea from '../../../assets/img/carousel/Mahabalipuram/7-sea.png';
import MahabalipuramSeaBg from '../../../assets/img/carousel/Mahabalipuram/8-sea-bg.png';

/* Mysore images */
import MysoreFrontTukTuk from '../../../assets/img/carousel/Mysore/1-tuk-tuk.png';
import MysoreFrontPeople from '../../../assets/img/carousel/Mysore/2-character.png';
import MysoreLeftGang from '../../../assets/img/carousel/Mysore/3-gang.png';
import MysoreRightPalace from '../../../assets/img/carousel/Mysore/4-palace.png';
import MysoreLeftTemple from '../../../assets/img/carousel/Mysore/5-temple.png';
import MysoreLeftTree from '../../../assets/img/carousel/Mysore/6-tree.png';
import MysoreBackDeers from '../../../assets/img/carousel/Mysore/7-deers.png';

/* Nainital images */
import NainitalAnimals from '../../../assets/img/carousel/Nainital/1-animals.png';
import NainitalPeople from '../../../assets/img/carousel/Nainital/1-people.png';
import NainitalBushFront from '../../../assets/img/carousel/Nainital/2-bush-front.png';
import NainitalBushBack from '../../../assets/img/carousel/Nainital/3-bush-back.png';
import NainitalFavelasFront from '../../../assets/img/carousel/Nainital/2-favelas-front.png';
import NainitalFavelasBack from '../../../assets/img/carousel/Nainital/3-favelas-back.png';
import NainitalTemple from '../../../assets/img/carousel/Nainital/4-temple.png';
import NainitalBirds from '../../../assets/img/carousel/Nainital/5-birds.png';
import NainitalBoat from '../../../assets/img/carousel/Nainital/5-boat-lake.png';
import NainitalMountainsLeft from '../../../assets/img/carousel/Nainital/6-mountains-left.png';
import NainitalMountainsRight from '../../../assets/img/carousel/Nainital/6-mountains-right.png';
import NainitalMountainsBgFront from '../../../assets/img/carousel/Nainital/8-mountains-bg-front.png';
import NainitalMountainsBgBack from '../../../assets/img/carousel/Nainital/9-mountains-bg-back.png';
import NainitalLake from '../../../assets/img/carousel/Nainital/7-lake.png';
import NainitalTelesiege from '../../../assets/img/carousel/Nainital/7-telesiege.png';
import NainitalLakeBg from '../../../assets/img/carousel/Nainital/9-lake-bg.png';

function transitionsParallaxAnimation(options) {

    const hash = options.name || ''
    const distance = `${40*options.z}px`
    const enterDistance = `${60*options.z}px`

    return `

    &.${TRANSITION_CLASS_LEFT} {
        animation: leaving-left-${hash} ${TRANSITION_DURATION*0.75}s ease-in-out;
        transform: translate(${distance});
    }
    &.${TRANSITION_CLASS_RIGHT} {
        animation: leaving-right-${hash} ${TRANSITION_DURATION*0.75}s ease-in-out;
        transform: translate(-${distance});
    }
    &.${ENTRANCE_CLASS_RIGHT} {
        animation: entrance-right-${hash} ${TRANSITION_DURATION*0.9}s ease-in-out;
    }
    &.${ENTRANCE_CLASS_LEFT} {
        animation: entrance-left-${hash} ${TRANSITION_DURATION*0.9}s ease-in-out;
    }
    
    @keyframes leaving-left-${hash} {
        from {
            transform: translate(0);
        }
        to {
            transform: translate(${distance});
        }
    }

    @keyframes leaving-right-${hash} {
        from {
            transform: translate(0);
        }
        to {
            transform: translate(-${distance});
        }
    }

    @keyframes entrance-right-${hash} {
        from {
            transform: translate(${enterDistance});
        }
        to {
            transform: translate(0);
        }
    }

    @keyframes entrance-left-${hash} {
        from {
            transform: translate(-${enterDistance});
        }
        to {
            transform: translate(0);
        }
    }
    
    `
}

const Layer = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    height: 100%;
    width: 100%;

    grid-column-start: ${props => props.data.columnStart};
    grid-column-end: ${props => props.data.columnEnd};
    grid-row-start: ${props => props.data.rowStart};
    grid-row-end: ${props => props.data.rowEnd};
    z-index: ${props => props.data.zindex};

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        justify-content: center;
    }

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        max-height: 150%;
    }

    `;
    
    const Image = styled.img`
    width: auto;
    height: auto;
    z-index: inherit;
    will-change: transform;
    
    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        max-height: 100%;
    }

    ${props => transitionsParallaxAnimation({ z:props.z, name: `layer-${props.z}` })}
`;

const Collage = styled.div`
    position: relative;
    display: grid;

    width: 100%;
    height: 60%;
    max-width: 1200px;
    max-height: 600px;

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        width: 1000px;
    }
`;

const CollageWrapper = styled.div`
    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        transform: scale(0.8);
    }

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        transform: scale(0.6);
    }
`

const MahabalipuramCollage = styled(Collage)`
    grid-template-columns: 2fr 3fr 11fr 23fr 15fr 15fr 10fr 10fr 2fr 13fr 44fr 19fr 10fr 14fr 9fr 5fr 11fr 12fr 18fr;
    grid-template-rows: 15fr 8fr 4fr 8fr 6fr 24fr 5fr 5fr 4fr 7fr 4fr 11fr 1fr;
`;

const MysoreCollage = styled(Collage)`
    grid-template-columns: 7fr 10fr 8fr 2fr 2fr 3fr 8fr 4fr 1fr 14fr 12fr 11fr 5fr 16fr 13fr 7fr;
    grid-template-rows: 5fr 4fr 3fr 14fr 5fr 2fr 3fr 2fr 3fr 5fr 6fr 5fr 1fr;
`;

const NainitalCollage = styled(Collage)`
    grid-template-columns: 22fr 20fr 9fr 16fr 13fr 4fr 5fr 21fr 15fr 32fr 7fr 3fr 80fr 13fr 48fr 11fr 8fr 11fr 3fr 37fr 30fr 7fr 12fr 16fr 9fr 23fr 7fr 11fr;
    grid-template-rows: 40fr 28fr 11fr 6fr 3fr 17fr 5fr 7fr 3fr 5fr 3fr 2fr 5fr 2fr 3fr 5fr 4fr 4fr 7fr 9fr 2fr 10fr 29fr 12fr 11fr;

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        grid-template-columns: 2fr 2fr 9fr 16fr 13fr 4fr 5fr 21fr 15fr 32fr 7fr 3fr 80fr 13fr 48fr 11fr 8fr 11fr 3fr 37fr 30fr 7fr 12fr 16fr 9fr 23fr 7fr 11fr;
    }
`;


const collageOptions = {
    'Mahabalipuram' : {
        component: MahabalipuramCollage,
        elements: [
            {
                src: MahabalipuramSeaBg,
                alt: 'blue and yellow amourphous shapes',
                speed: '3',
                data: {
                    columnStart: '2',
                    columnEnd: '13',
                    rowStart: '7',
                    rowEnd: '12',
                    zindex: '300'
                }
            },
            {
                src: MahabalipuramSea,
                alt: 'a deep blue sea',
                speed: '3',
                data: {
                    columnStart: '11',
                    columnEnd: '19',
                    rowStart: '8',
                    rowEnd: '12',
                    zindex: '300'
                }
            },
            {
                src: MahabalipuramGate,
                speed: '4',
                alt: 'a big old stone gate',
                data: {
                    columnStart: '6',
                    columnEnd: '15',
                    rowStart: '4',
                    rowEnd: '9',
                    zindex: '400'
                }
            },
            {
                src: MahabalipuramBirdsRight,
                speed: '5',
                alt: 'a group of flocking birds',
                data: {
                    columnStart: '14',
                    columnEnd: '18',
                    rowStart: '3',
                    rowEnd: '6',
                    zindex: '500'
                }
            },
            {
                src: MahabalipuramBirdsLeft,
                speed: '5',
                alt: 'a group of flocking birds',
                data: {
                    columnStart: '5',
                    columnEnd: '9',
                    rowStart: '2',
                    rowEnd: '5',
                    zindex: '500'
                }
            },
            {
                src: MahabalipuramRock,
                speed: '6',
                alt: 'a big rock',
                data: {
                    columnStart: '9',
                    columnEnd: '11',
                    rowStart: '8',
                    rowEnd: '12',
                    zindex: '600'
                }
            },
            {
                src: MahabalipuramTempleRight,
                speed: '7',
                alt: 'an old stone temple',
                data: {
                    columnStart: '12',
                    columnEnd: '16',
                    rowStart: '4',
                    rowEnd: '10',
                    zindex: '700'
                }
            },
            {
                src: MahabalipuramHouseLeft,
                speed: '7',
                alt: 'a house',
                data: {
                    columnStart: '4',
                    columnEnd: '8',
                    rowStart: '3',
                    rowEnd: '11',
                    zindex: '700'
                }
            },
            {
                src: MahabalipuramLighthouse,
                speed: '8',
                alt: 'a lighthouse',
                data: {
                    columnStart: '15',
                    columnEnd: '19',
                    rowStart: '5',
                    rowEnd: '13',
                    zindex: '800'
                }
            },
            {
                src: MahabalipuramFrontPeople,
                speed: '9',
                alt: 'a man and a woman in a motorcycle',
                data: {
                    columnStart: '13',
                    columnEnd: '16',
                    rowStart: '7',
                    rowEnd: '14',
                    zindex: '900'
                }
            },
            {
                src: MahabalipuramFrontCow,
                speed: '9',
                alt: 'a group of cows resting',
                data: {
                    columnStart: '3',
                    columnEnd: '7',
                    rowStart: '9',
                    rowEnd: '13',
                    zindex: '900'
                }
            }
        ]
    },
    'Mysore' : {
        component: MysoreCollage,
        elements: [
            {
                src: MysoreBackDeers,
                alt: 'a group of deers behind a meadow',
                speed: '1',
                data: {
                    columnStart: '3',
                    columnEnd: '14',
                    rowStart: '5',
                    rowEnd: '10',
                    zindex: '100'
                }
            },
            {
                src: MysoreLeftTree,
                alt: 'a big tree',
                speed: '4',
                data: {
                    columnStart: '2',
                    columnEnd: '6',
                    rowStart: '3',
                    rowEnd: '8',
                    zindex: '400'
                }
            },
            {
                src: MysoreLeftTemple,
                alt: 'a big tall stone temple',
                speed: '5',
                data: {
                    columnStart: '4',
                    columnEnd: '8',
                    rowStart: '4',
                    rowEnd: '8',
                    zindex: '500'
                }
            },
            {
                src: MysoreRightPalace,
                alt: 'a white palace with some palm trees',
                speed: '6',
                data: {
                    columnStart: '11',
                    columnEnd: '16',
                    rowStart: '2',
                    rowEnd: '9',
                    zindex: '600'
                }
            },
            {
                src: MysoreLeftGang,
                alt: 'a group of people carrying some plants',
                speed: '7',
                data: {
                    columnStart: '5',
                    columnEnd: '10',
                    rowStart: '6',
                    rowEnd: '11',
                    zindex: '700'
                }
            },
            {
                src: MysoreFrontPeople,
                alt: 'a man and a woman standing looking at the scene',
                speed: '8',
                data: {
                    columnStart: '3',
                    columnEnd: '7',
                    rowStart: '7',
                    rowEnd: '12',
                    zindex: '800'
                }
            },
            {
                src: MysoreFrontTukTuk,
                alt: 'an old lady sitting by a tuk tuk',
                speed: '9',
                data: {
                    columnStart: '12',
                    columnEnd: '15',
                    rowStart: '6',
                    rowEnd: '13',
                    zindex: '900'
                }
            },
        ]
    },
    'Nainital': {
        component: NainitalCollage,
        elements: [
            {
                src: NainitalLakeBg,
                alt: '2 blue and pink amourphous shapes',
                speed: '1',
                data: {
                    columnStart: '4',
                    columnEnd: '28',
                    rowStart: '16',
                    rowEnd: '23',
                    zindex: '100'
                }
            },
            {
                src: NainitalLake,
                alt: 'a big blue lake',
                speed: '3',
                data: {
                    columnStart: '11',
                    columnEnd: '21',
                    rowStart: '12',
                    rowEnd: '22',
                    zindex: '300'
                }
            },
            {
                src: NainitalTelesiege,
                alt: 'a telesiege',
                speed: '3',
                data: {
                    columnStart: '17',
                    columnEnd: '19',
                    rowStart: '5',
                    rowEnd: '11',
                    zindex: '300'
                }
            },
            {
                src: NainitalMountainsBgBack,
                alt: 'mountains',
                speed: '1',
                data: {
                    columnStart: '10',
                    columnEnd: '22',
                    rowStart: '6',
                    rowEnd: '9',
                    zindex: '100'
                }
            },
            {
                src: NainitalMountainsBgFront,
                alt: 'mountains',
                speed: '2',
                data: {
                    columnStart: '8',
                    columnEnd: '23',
                    rowStart: '7',
                    rowEnd: '14',
                    zindex: '200'
                }
            },
            {
                src: NainitalMountainsRight,
                alt: 'a big mountain',
                speed: '4',
                data: {
                    columnStart: '16',
                    columnEnd: '26',
                    rowStart: '6',
                    rowEnd: '15',
                    zindex: '400'
                }
            },
            {
                src: NainitalMountainsLeft,
                alt: 'a big mountain',
                speed: '4',
                data: {
                    columnStart: '3',
                    columnEnd: '15',
                    rowStart: '4',
                    rowEnd: '20',
                    zindex: '400'
                }
            },
            {
                src: NainitalBoat,
                alt: 'a small boat',
                speed: '5',
                data: {
                    columnStart: '14',
                    columnEnd: '15',
                    rowStart: '14',
                    rowEnd: '17',
                    zindex: '300'
                }
            },
            {
                src: NainitalBirds,
                alt: 'a group of flocking birds',
                speed: '5',
                data: {
                    columnStart: '19',
                    columnEnd: '25',
                    rowStart: '2',
                    rowEnd: '4',
                    zindex: '500'
                }
            },
            {
                src: NainitalTemple,
                alt: 'a big white temple',
                speed: '6',
                data: {
                    columnStart: '3',
                    columnEnd: '13',
                    rowStart: '3',
                    rowEnd: '20',
                    zindex: '600'
                }
            },
            {
                src: NainitalFavelasBack,
                alt: 'a group of small houses',
                speed: '7',
                data: {
                    columnStart: '19',
                    columnEnd: '27',
                    rowStart: '8',
                    rowEnd: '18',
                    zindex: '700'
                }
            },
            {
                src: NainitalFavelasFront,
                alt: 'a group of small houses',
                speed: '8',
                data: {
                    columnStart: '20',
                    columnEnd: '28',
                    rowStart: '10',
                    rowEnd: '20',
                    zindex: '800'
                }
            },
            {
                src: NainitalBushBack,
                alt: 'a medium sized bush',
                speed: '7',
                data: {
                    columnStart: '2',
                    columnEnd: '6',
                    rowStart: '14',
                    rowEnd: '21',
                    zindex: '700'
                }
            },
            {
                src: NainitalBushFront,
                alt: 'a small sized bush',
                speed: '8',
                data: {
                    columnStart: '5',
                    columnEnd: '9',
                    rowStart: '17',
                    rowEnd: '22',
                    zindex: '800'
                }
            },
            {
                src: NainitalPeople,
                alt: 'a group of people',
                speed: '9',
                data: {
                    columnStart: '7',
                    columnEnd: '12',
                    rowStart: '13',
                    rowEnd: '25',
                    zindex: '900'
                }
            },
            {
                src: NainitalAnimals,
                alt: 'a group of animals',
                speed: '9',
                data: {
                    columnStart: '18',
                    columnEnd: '24',
                    rowStart: '19',
                    rowEnd: '24',
                    zindex: '900'
                }
            }
        ]
    }
}

const BackgroundCollage = (props) => {
    const [mouseX, setMouseX] = useState(window.innerWidth/2)
    const [mouseY, setMouseY] = useState(window.innerHeight/2)

    const city = props.city;
    const Collage = collageOptions[props.city].component;

    function parallax(e) {
        if (window.innerWidth > 568) {
            setMouseX(e.clientX)
            setMouseY(e.clientY)
        }
    };

    useEffect(() => {
        document.addEventListener('mousemove', parallax);
        return () => {
          document.removeEventListener('mousemove', parallax);
        };
      }, []);

    const layers = collageOptions[city].elements.map((layer, i) => {
        const x = (mouseX - window.innerWidth/2) / 70 * layer.speed
        const y = (mouseY - window.innerHeight/2) / 400 * layer.speed
        const transform = `translate3d(${x}px,${y}px,0)`

        return (<Layer data={layer.data} key={i} style={{ transform }} >
            <Image alt={layer.alt} src={layer.src} className={props.transitionClassName} z={layer.speed}></Image>
        </Layer>)
    })


    return (
        <CollageWrapper>
            <Collage className={[ props.className, props.transitionClassName ]}>
                {layers}
            </Collage>
        </CollageWrapper>
    );
};

export default BackgroundCollage;